import { CFBaseAvatarTokens } from '.';
export const getAvatarSize = (size) => {
    if (typeof size === 'number') {
        return size;
    }
    return CFBaseAvatarTokens.SIZES[size.toUpperCase()];
};
export const getFontSize = (size) => {
    if (typeof size === 'number') {
        return Math.round(size * 0.43);
    }
    return CFBaseAvatarTokens.FONT_SIZES[size.toUpperCase()];
};
export const getSquircleBorderRadius = (size) => {
    if (typeof size === 'number') {
        return Math.round(size * 0.33);
    }
    return CFBaseAvatarTokens.BORDER_RADII_SQUIRCLE[size.toUpperCase()];
};
